export enum ZIndex {
  Page = 1,
  Sticky = 500,
  Dialog = 1000, // per @fluentui/react-northstar
  DropDown = 1000000, // per @fluentui/react
  LoaderDim = 1000001,
  Loader = 1000002
}
